import { CategoryColor } from '../api/api.ts';

export const gradientClassesForColor = (color: CategoryColor) => {
  switch (color) {
    case CategoryColor.Red:
      return ['bg-linear-to-br', 'from-cliwac-red-light', 'to-cliwac-red'];
    case CategoryColor.Green:
      return ['bg-linear-to-br', 'from-cliwac-green-light', 'to-cliwac-green'];
    case CategoryColor.Blue:
      return ['bg-linear-to-br', 'from-cliwac-blue-light', 'to-cliwac-blue'];
  }
};
export const backgroundColorClassesForColor = (color: CategoryColor) => {
  switch (color) {
    case CategoryColor.Red:
      return ['bg-cliwac-red'];
    case CategoryColor.Green:
      return ['bg-cliwac-green'];
    case CategoryColor.Blue:
      return ['bg-cliwac-blue'];
  }
};

export const fromColorClassesForColor = (color: CategoryColor) => {
  switch (color) {
    case CategoryColor.Red:
      return ['from-cliwac-red'];
    case CategoryColor.Green:
      return ['from-cliwac-green'];
    case CategoryColor.Blue:
      return ['from-cliwac-blue'];
  }
};
export const viaColorClassesForColor = (color: CategoryColor) => {
  switch (color) {
    case CategoryColor.Red:
      return ['via-cliwac-red'];
    case CategoryColor.Green:
      return ['via-cliwac-green'];
    case CategoryColor.Blue:
      return ['via-cliwac-blue'];
  }
};
export const toColorClassesForColor = (color: CategoryColor) => {
  switch (color) {
    case CategoryColor.Red:
      return ['to-cliwac-red'];
    case CategoryColor.Green:
      return ['to-cliwac-green'];
    case CategoryColor.Blue:
      return ['to-cliwac-blue'];
  }
};

export const borderColorClassesForColor = (color: CategoryColor) => {
  switch (color) {
    case CategoryColor.Red:
      return ['border-cliwac-red'];
    case CategoryColor.Green:
      return ['border-cliwac-green'];
    case CategoryColor.Blue:
      return ['border-cliwac-blue'];
  }
};

export const borderLeftColorClassesForColor = (color: CategoryColor) => {
  switch (color) {
    case CategoryColor.Red:
      return ['border-l-cliwac-red'];
    case CategoryColor.Green:
      return ['border-l-cliwac-green'];
    case CategoryColor.Blue:
      return ['border-l-cliwac-blue'];
  }
};

export const hoverBackgroundColorClassesForColor = (color: CategoryColor) => {
  switch (color) {
    case CategoryColor.Red:
      return ['hover:bg-cliwac-red'];
    case CategoryColor.Green:
      return ['hover:bg-cliwac-green'];
    case CategoryColor.Blue:
      return ['hover:bg-cliwac-blue'];
  }
};

export const textColorClassesForColor = (color: CategoryColor) => {
  switch (color) {
    case CategoryColor.Red:
      return ['text-cliwac-red'];
    case CategoryColor.Green:
      return ['text-cliwac-green'];
    case CategoryColor.Blue:
      return ['text-cliwac-blue'];
  }
};

export const hoverTextColorClassesForColor = (color: CategoryColor) => {
  switch (color) {
    case CategoryColor.Red:
      return ['hover:text-cliwac-red'];
    case CategoryColor.Green:
      return ['hover:text-cliwac-green'];
    case CategoryColor.Blue:
      return ['hover:text-cliwac-blue'];
  }
};

export const hexColorForCategoryColor = (color: CategoryColor) => {
  switch (color) {
    case CategoryColor.Red:
      return '#ed5667';
    case CategoryColor.Green:
      return '#39bc9d';
    case CategoryColor.Blue:
      return '#4c89dc';
  }
};
